(function (Translator) {
    // en
    Translator.add("add", "Add", "EvpPageBundle", "en");
    Translator.add("delete", "Delete", "EvpPageBundle", "en");
    Translator.add("edit", "Edit", "EvpPageBundle", "en");
    Translator.add("evp_page.page.duplicated_route", "This URL is linked to another page.", "EvpPageBundle", "en");
    Translator.add("form.hide", "Hide", "EvpPageBundle", "en");
    Translator.add("form.show", "Show", "EvpPageBundle", "en");
    Translator.add("layout_delete.error", "Error deleting template", "EvpPageBundle", "en");
    Translator.add("layout_delete.success", "Template deleted", "EvpPageBundle", "en");
    Translator.add("layout_edit.success", "Template updated successfully", "EvpPageBundle", "en");
    Translator.add("layout_edit.title", "Add a template", "EvpPageBundle", "en");
    Translator.add("layout_option.pdf_button", "Show PDF button", "EvpPageBundle", "en");
    Translator.add("layout_option.print_button", "Show print button", "EvpPageBundle", "en");
    Translator.add("layouts.title", "Templates", "EvpPageBundle", "en");
    Translator.add("page_block.button.close", "Close", "EvpPageBundle", "en");
    Translator.add("page_block.button.save", "Save", "EvpPageBundle", "en");
    Translator.add("page_block.error.content.empty", "Contents cannot be empty", "EvpPageBundle", "en");
    Translator.add("page_block.error.title.empty", "Name cannot be empty", "EvpPageBundle", "en");
    Translator.add("page_block.error.type.empty", "Please select a type", "EvpPageBundle", "en");
    Translator.add("page_block.form.block_type.title", "Type", "EvpPageBundle", "en");
    Translator.add("page_block.form.field.content", "Contents", "EvpPageBundle", "en");
    Translator.add("page_block.form.field.title", "Name", "EvpPageBundle", "en");
    Translator.add("page_block.modal_title.add", "Add page block", "EvpPageBundle", "en");
    Translator.add("page_block.modal_title.edit", "Edit page block", "EvpPageBundle", "en");
    Translator.add("page_delete.dialog.confirm", "Yes", "EvpPageBundle", "en");
    Translator.add("page_delete.dialog.content", "Are you sure you want to delete: ", "EvpPageBundle", "en");
    Translator.add("page_delete.dialog.decline", "No", "EvpPageBundle", "en");
    Translator.add("page_delete.dialog.title", "Confirm deletion", "EvpPageBundle", "en");
    Translator.add("page_delete.error", "Error deleting the page", "EvpPageBundle", "en");
    Translator.add("page_delete.success", "Page deleted", "EvpPageBundle", "en");
    Translator.add("page_edit.success", "Page updated successfully", "EvpPageBundle", "en");
    Translator.add("page_edit.title", "Add a page", "EvpPageBundle", "en");
    Translator.add("page.back", "Back", "EvpPageBundle", "en");
    Translator.add("page.content_not_found", "Sorry, this page is not available in English language.", "EvpPageBundle", "en");
    Translator.add("page.content.not_found", "Page address is incorrect or has mysteriously disappeared...", "EvpPageBundle", "en");
    Translator.add("page.heading.not_found", "Page not found :( ", "EvpPageBundle", "en");
    Translator.add("page.meta.add", "add", "EvpPageBundle", "en");
    Translator.add("page.meta.canonical_url", "canonical_url", "EvpPageBundle", "en");
    Translator.add("page.meta.description", "description", "EvpPageBundle", "en");
    Translator.add("page.meta.locale", "Locale", "EvpPageBundle", "en");
    Translator.add("page.meta.no_index", "no_index", "EvpPageBundle", "en");
    Translator.add("page.meta.no_items", "No meta", "EvpPageBundle", "en");
    Translator.add("page.meta.remove", "Remove", "EvpPageBundle", "en");
    Translator.add("page.meta.title", "Title", "EvpPageBundle", "en");
    Translator.add("page.not_found.alternative_page.content", "Sorry, but this page is only available in these languages", "EvpPageBundle", "en");
    Translator.add("page.not_found.alternative_page.heading", "There is no page in this language", "EvpPageBundle", "en");
    Translator.add("page.not_found.alternative_page.homepage_button", "Back to homepage", "EvpPageBundle", "en");
    Translator.add("page.route.add", "Add", "EvpPageBundle", "en");
    Translator.add("page.route.no_items", "No routes", "EvpPageBundle", "en");
    Translator.add("page.route.remove", "Remove", "EvpPageBundle", "en");
    Translator.add("page.title.not_found", "Page not found - Paysera", "EvpPageBundle", "en");
    Translator.add("pages.title", "Pages", "EvpPageBundle", "en");
    Translator.add("paginator.next", "Next \u2192", "EvpPageBundle", "en");
    Translator.add("paginator.prev", "\u2190 Previous", "EvpPageBundle", "en");
})(Translator);
